import { useMutation } from "@tanstack/react-query"
import { Loader2Icon } from "lucide-react"
import { useState } from "react"
import { getNextVerificationStep } from "@/api/api"
import { useCurrentToken } from "@/lib/use-current-token"
import {
  useNextStepRedirect,
  useVerificationRedirect,
  verificationRoute,
} from "@/lib/use-verification-redirect"
import { parseError } from "@/lib/utils"
import { Alert } from "./ui/alert"
import { Button } from "./ui/button"

const NextStep = (props: { beforeContinue?: () => Promise<null> }) => {
  const { token_id } = useCurrentToken()
  const [isRedirecting, setIsRedirecting] = useState(false)
  const redirectToNextStep = useNextStepRedirect(`/${token_id}`)
  const redirectToMissingStep = useVerificationRedirect(
    `/${token_id}`,
    verificationRoute,
  )

  const mutation = useMutation({
    mutationKey: ["getNextStep", { token_id }],
    mutationFn: async () => {
      if (props.beforeContinue) {
        await props.beforeContinue()
      }
      return await getNextVerificationStep()
    },
    onSuccess: (res) => {
      // Keep the button busy while the browser leaves for the signing service
      if (res.redirect_url) {
        setIsRedirecting(true)
      }
      redirectToNextStep(res)
    },
    onError: redirectToMissingStep,
  })

  return (
    <div className="flex w-full flex-col items-center gap-4">
      {mutation.isError && (
        <Alert variant="destructive" className="w-full md:w-auto">
          {parseError(mutation.error)}
        </Alert>
      )}
      <Button
        className="w-full md:w-auto"
        disabled={mutation.isPending || isRedirecting}
        onClick={() => mutation.mutate()}
      >
        {mutation.isPending || isRedirecting ? (
          <>
            <Loader2Icon className="mr-2 animate-spin" />
            <span>Cargando...</span>
          </>
        ) : (
          <span>Continuar</span>
        )}
      </Button>
    </div>
  )
}

export { NextStep }
